import React from 'react';
import '../../styles/mainContents.css'
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

function BatteryHeader(props) {

  const history = useHistory();

  const { authreducer, pageTitle } = props;
  console.log("BatteryHeader authreducer: " + JSON.stringify(authreducer));  

  const routeChange_batteryCorporate = () =>{ 
    let path = `/battery/corporate`; 
    history.push(path);
  }

  
  return (

    <div className="mainCN">
      {console.log('BatteryHeader called')}

      <div className='MainPageCN'>      
        <div className="MainPageHeading">                  
          <h1 className="MainPageTitle">
            <div>Battery Program {pageTitle}</div>
            <div className='svrtms' style={ {float:'left'} }>{ moment().format("llll") } </div>
          </h1>
          <div style={ {clear: 'both'}}></div>
          <ul id='nav'>
            <li>
              <button
                onClick={ () => {
                  routeChange_batteryCorporate()
                }}
                > Corporate
              </button> 
            </li>
            <li>
              <button
                onClick={ () => {
                  routeChange_batteryCorporate()
                }}
                > Warehouse
              </button> 
            </li>            
          </ul>
        </div>        
      </div>
    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("BatteryHeader mapStateToProps state: " + JSON.stringify(state));
 return {
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  //console.log("BatteryHeader mapDispatchToProps called ");
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BatteryHeader);